import { OneActorT } from 'shared/api/types/services';
import ModelInfo, { InfoBoxesT } from 'shared/components/ModelInfo';

interface Props {
  data: OneActorT['response'];
}

const Info = ({ data }: Props) => {
  const infoBoxes: InfoBoxesT = [
    {
      label: 'Name',
      type: 'text',
      value: data.name,
    },
    {
      label: 'Nick',
      type: 'text',
      value: data.nick,
    },
    {
      label: 'Phone',
      type: 'text',
      value: data.phone,
    },
    {
      label: 'Sex',
      type: 'text',
      value: data.sex,
    },
    {
      label: 'Bio',
      type: 'text',
      value: data.bio,
    },
    {
      label: 'Description',
      type: 'text',
      value: data.description,
    },
    {
      label: 'Api Hash',
      type: 'copy-text',
      value: {
        label: data.apiHash,
        valueToCopy: data.apiHash,
      },
    },
  ]

  return (
    <ModelInfo infoBoxes={infoBoxes} />
  );
};

export default Info;
